import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import { useGetTeamInstagramIntegrations } from '../../services/meta.service';
import { useIntegrationsStore } from '../../store';

export const useGetInstagramIntegrations = () => {
  const { getTeamInstagramIntegrations } = useGetTeamInstagramIntegrations();
  const { setTeamInstagramIntegrations } = useIntegrationsStore();

  const handleFetchInstagramIntegrations = (
    teamId: string,
    forceRefresh = false,
  ) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.INSTAGRAM,
      scope: teamId,
      forceRefresh,
      fetch: () => getTeamInstagramIntegrations(teamId),
      write: setTeamInstagramIntegrations,
    });

  return { handleFetchInstagramIntegrations };
};
